import type { TCreateContactBody } from "@api";
import type { ContactType } from "@bbj-types/contact/enum";
import { isValidPhoneNumber } from "@root/utils/phoneLib";
import type { ResolverResult } from "react-hook-form";

export type TContactForm = Omit<TCreateContactBody<ContactType.ENTERPRISE>, "enterprise" | "isTemp">;

export const resolver = (values: TContactForm): ResolverResult<TContactForm> => {
  const errors = { phone: "", email: "" };
  if (values.email && !values.email.match(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/)) {
    errors.email = "pattern";
  }
  if (values.phone && !isValidPhoneNumber(values.phone)) {
    errors.phone = "pattern";
  }
  if (!values.email && !values.phone) {
    errors.email = "required";
    errors.phone = "required";
  }
  if (errors.email || errors.phone || !values.place) {
    return {
      values: {},
      errors: {
        email: errors.email
          ? {
              type: errors.email,
              message: errors.email === "pattern" ? "Le format de l'email n'est pas valide" : undefined,
            }
          : undefined,
        phone: errors.phone
          ? {
              type: errors.phone,
              message: errors.phone === "pattern" ? "Le format du numéro n'est pas valide" : undefined,
            }
          : undefined,
        place: !values.place ? { type: "required", message: "Ce champ est obligatoire" } : undefined,
      },
    };
  }
  return {
    values: values,
    errors: {},
  };
};
